import type { Dayjs } from 'dayjs';

/**
 * @returns Period range corresponding to provided from, to and timeWindowShift
 */
export const getPeriodFromCustomDate = (
  from: Dayjs,
  to: Dayjs,
  timeWindowShift = 0,
): { dateFrom: Dayjs; dateTo: Dayjs } => {
  // NOTE: we are using endOf/startOf('day') when working with custom dates dayDiff should be minimum 1 when shifting time window
  const dayDiff = Math.floor(Math.abs(from.diff(to, 'day', true)) + 1);

  const dateFrom = from.add(timeWindowShift * dayDiff, 'day').startOf('day');
  const dateTo = to.add(timeWindowShift * dayDiff, 'day').endOf('day');

  return { dateFrom, dateTo };
};
